import { stateAbbreviationDatabase } from '@zorro/shared/databases';

export const stateNameByCode: Record<string, string> = Object.fromEntries(
  stateAbbreviationDatabase.map(({ abbreviation, name }) => [
    abbreviation,
    name,
  ])
);

export const stateCodes = new Set([
  'AL',
  'AK',
  'AZ',
  'AR',
  'CA',
  'CO',
  'CT',
  'DE',
  'DC', // District of Columbia [Not a state]
  'FL',
  'GA',
  'HI',
  'ID',
  'IL',
  'IN',
  'IA',
  'KS',
  'KY',
  'LA',
  'ME',
  'MD',
  'MA',
  'MI',
  'MN',
  'MS',
  'MO',
  'MT',
  'NE',
  'NV',
  'NH',
  'NJ',
  'NM',
  'NY',
  'NC',
  'ND',
  'OH',
  'OK',
  'OR',
  'PA',
  'RI',
  'SC',
  'SD',
  'TN',
  'TX',
  'UT',
  'VT',
  'VA',
  'VI', // Virgin Islands [Not a state, a U.S. territory]
  'WA',
  'WV',
  'WI',
  'WY',
]);
